import { Search } from "lucide-react";
import { useState, useEffect, useMemo } from "react";
import FilterSidebar from "../../components/customer/FilterSidebar";
import { useLazyGetAllBrandsQuery } from "../../redux/actions/Admin/ProductAdmin";
import { useNavigate } from "react-router-dom";

const CustomerBrandListingScreen: React.FC = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const BrandBanner =
    "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=1600&q=80";
  const [getAllBrands, { data: brandsData, isLoading }] =
    useLazyGetAllBrandsQuery();

  useEffect(() => {
    getAllBrands();
  }, [getAllBrands]);

  const brands = useMemo(() => {
    if (!brandsData) return [];

    return brandsData
      .filter((brand: any) => brand.isActive && !brand.isDeleted)
      .filter((brand: any) =>
        brand.name.toLowerCase().includes(search.toLowerCase())
      );
  }, [brandsData, search]);

  const handleBrandClick = (brand: any) => {
    console.log(brand, "brand")
    navigate("/productpage/productListingScreen", {

      state: {
        source: "Brand",
        data: {
          brandId: brand.id,
        },
        brandName: brand.name,
      },
    });
  };
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex flex-col lg:flex-row gap-8 items-start">

        {/* Content */}
        <main className="flex-1 w-full">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 pb-4 border-b border-gray-100">
            <h1 className="text-2xl font-bold text-logoHeading">
              Explore Brands
            </h1>

            <div className="relative w-full sm:w-[320px]">
              <Search
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              />

              <input
                type="text"
                placeholder="Search Brands..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full rounded-xl border border-gray-200 bg-gray-50 pl-10 pr-4 py-2 outline-none focus:border-amber-500"
              />
            </div>
          </div>

          {/* Banner */}
          <div className="relative mb-10 overflow-hidden rounded-3xl">
            <img
              src={BrandBanner}
              alt="Explore Brands"
              className="h-56 w-full object-cover lg:h-72"
            />

            <div className="absolute inset-0 bg-black/35" />

            <div className="absolute inset-0 flex flex-col justify-center px-8 text-white">
              <h2 className="text-3xl font-bold lg:text-4xl">
                Premium Pet Brands
              </h2>

              <p className="mt-2 max-w-lg text-sm lg:text-base text-white/90">
                Discover trusted brands for your pets, from premium nutrition to
                everyday essentials.
              </p>
            </div>
          </div>

          {/* Loading */}
          {isLoading && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
              {Array.from({ length: 8 }).map((_, index) => (
                <div
                  key={index}
                  className="h-52 rounded-2xl bg-gray-100 animate-pulse"
                />
              ))}
            </div>
          )}

          {/* Empty */}
          {!isLoading && brands.length === 0 && (
            <div className="flex justify-center py-20">
              <p className="text-gray-500">No Brands Found</p>
            </div>
          )}

          {/* Brand Grid */}
          {!isLoading && brands.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-8 gap-y-12">
              {brands.map((brand: any) => (
                <button
                  key={brand.id}
                  onClick={() => handleBrandClick(brand)}
                  className="group flex flex-col items-center text-center transition-all duration-300"
                >
                  {/* Logo */}
                  <div className="flex h-28 w-full items-center justify-center">
                    {brand.logoUrl ? (
                      <img
                        src={brand.logoUrl}
                        alt={brand.name}
                        className="max-h-20 max-w-[140px] object-contain transition duration-300 group-hover:scale-105"
                      />
                    ) : (
                      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-slate-100 text-3xl font-bold text-slate-600 transition duration-300 group-hover:bg-amber-100 group-hover:text-amber-600">
                        {brand.name.charAt(0)}
                      </div>
                    )}
                  </div>

                  {/* Name */}
                  <h3 className="mt-3 text-base font-semibold text-slate-800 transition-colors group-hover:text-amber-600">
                    {brand.name}
                  </h3>

                  {/* Small line */}
                  <div className="mt-2 h-0.5 w-0 rounded-full bg-amber-500 transition-all duration-300 group-hover:w-10" />
                </button>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default CustomerBrandListingScreen;
